import { useMediaQuery } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { MobileListRow } from "features/MobileListRow";
import {
  List,
  Datagrid,
  SimpleList,
  TextField,
  BooleanField,
  ReferenceField,
  SelectInput,
  ListActions,
  EditButton,
  ShowButton,
  ReferenceInput,
  FunctionField,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import GenerateCertificateButton from "./components/GenerateCertificateButton";

const ListFilters = [
  <ReferenceInput
    source="mobilityVisitType"
    reference={erasmusRequests.getMobilityTypesSelect()}
    alwaysOn
  >
    <SelectInput
      label="Тип визита"
      optionText="nameBg"
    />
  </ReferenceInput>,
];

const ListErasmusIncomingTeachers = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();
  return (
    <List
      filters={ListFilters}
      sx={settings.style.blockStyle}
      exporter={false}
      actions={
        <ListActions hasCreate={checkPermission(userPermissions, permissions.canManageErasmusIncomingTeachers)} />
      }
      title="Пристигащи преподаватели"
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Имена", value: `${record.firstNameLatin} ${record.lastNameLatin}` }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "ID", value: record.id }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Университет",
                    value: (
                      <ReferenceField
                        label="Университет"
                        source="universityId"
                        reference={administrationRequests.getUniversitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />

              <MobileListRow
                fields={[
                  {
                    label: "Тип",
                    value: (
                      <ReferenceField
                        label="Тип визита"
                        source="mobilityVisitType"
                        reference={erasmusRequests.getMobilityTypesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Приключил",
                    value: <BooleanField source="isCompleted" />,
                  },
                ]}
              />
              {record.isCompleted && (
                <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
                  <div>
                    <GenerateCertificateButton
                      id={record.id}
                      type="stay"
                    />
                    <GenerateCertificateButton
                      id={record.id}
                      type="teaching"
                    />
                  </div>
                </SecuredComponent>
              )}
            </div>
          )}
          tertiaryText={rec => (
            <>
              <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewErasmusIncomingTeachers}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="id"
            label="ID"
            sortable={false}
          />
          <TextField
            source="firstNameLatin"
            label="Име (латиница)"
            sortable={false}
          />
          <TextField
            source="lastNameLatin"
            label="Фамилия (латиница)"
            sortable={false}
          />
          <ReferenceField
            label="Университет"
            source="universityId"
            reference={administrationRequests.getUniversitiesSelect()}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Тип визита"
            source="mobilityVisitType"
            reference={erasmusRequests.getMobilityTypesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <BooleanField
            source="isCompleted"
            label="Приключил"
            sortable={false}
          />
          <FunctionField
            label=""
            sortable={false}
            render={record =>
              record?.isCompleted ? (
                <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
                  <GenerateCertificateButton
                    id={record.id}
                    type="stay"
                  />
                </SecuredComponent>
              ) : null
            }
          />
          <FunctionField
            label=""
            sortable={false}
            render={record =>
              record?.isCompleted ? (
                <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
                  <GenerateCertificateButton
                    id={record.id}
                    type="teaching"
                  />
                </SecuredComponent>
              ) : null
            }
          />
          <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewErasmusIncomingTeachers}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListErasmusIncomingTeachers;
